export default __webpack_public_path__ + "static/media/ipfs.3552be3c.svg";